import React from 'react';
import { motion } from 'framer-motion';

const Card = ({
  children,
  className = '',
  hover = true,
  padding = 'medium',
  shadow = 'medium',
  rounded = 'large',
  background = 'white',
  border = false,
  ...props
}) => {
  const paddings = {
    small: 'p-4',
    medium: 'p-6',
    large: 'p-8',
    none: 'p-0'
  };

  const shadows = {
    none: '',
    small: 'shadow-sm',
    medium: 'shadow-lg shadow-pragyavan-brown/5',
    large: 'shadow-xl shadow-pragyavan-brown/10'
  };

  const roundedClasses = {
    none: '',
    small: 'rounded-md',
    medium: 'rounded-lg',
    large: 'rounded-xl',
    full: 'rounded-2xl'
  };

  const backgrounds = {
    white: 'bg-soft-white',
    cream: 'bg-pragyavan-cream',
    gold: 'bg-pragyavan-gold',
    transparent: 'bg-transparent',
    glass: 'bg-white/80 backdrop-blur-md border border-white/20 shadow-glass'
  };

  const baseClasses = `
    ${backgrounds[background]}
    ${paddings[padding]}
    ${shadows[shadow]}
    ${roundedClasses[rounded]}
    ${border ? 'border border-warm-gray/10' : ''}
    ${hover ? 'hover:shadow-xl hover:shadow-pragyavan-brown/8 transition-all duration-300' : ''}
    ${className}
  `.trim();

  if (hover) {
    return (
      <motion.div
        whileHover={{ y: -2 }}
        transition={{ type: "spring", stiffness: 300, damping: 30 }}
        className={baseClasses}
        {...props}
      >
        {children}
      </motion.div>
    );
  }

  return (
    <div className={baseClasses} {...props}>
      {children}
    </div>
  );
};

const CardHeader = ({ children, className = '', ...props }) => (
  <div className={`mb-4 ${className}`} {...props}>
    {children}
  </div>
);

const CardBody = ({ children, className = '', ...props }) => (
  <div className={`${className}`} {...props}>
    {children}
  </div>
);

const CardFooter = ({ children, className = '', ...props }) => (
  <div className={`mt-4 pt-4 ${className}`} {...props}>
    {children}
  </div>
);

Card.Header = CardHeader;
Card.Body = CardBody;
Card.Footer = CardFooter;

export default Card;